import { api } from '../../axios.instance';

// Restricted: the backend returns 403 unless the user has been granted
// canDownloadStaffTemplate by a super admin.
export const downloadStaffImportTemplate = () => {
  return api.get('/staff/import-template', { responseType: 'blob' });
};
